import React, { Component }             from "react"
import Pagination                       from "components/Pagination/Pagination"
import "components/Filter/Filter.scss"
import { Button, Dropdown, Form, Menu } from "semantic-ui-react"
import shop                             from "shop/shop"
import {Link}                             from "react-router-dom"
import queryString                                                from "qs"

let sortOptions = [
  {
    key: "A-Z",
    text: translate( "A-Z" ),
    value: "des",
    params: { sort: "des", dir: "desc" }
  },
  {
    key: "Artikel-Nr.",
    text: translate( "Artikel Nr." ),
    value: "article_nr",
    params: { sort: "article_nr" , dir: "asc"}
  },
  {
    key: "Preis",
    text: translate( "Preis" ),
    value: "price",
    params: { sort: "price", dir: "desc" }
  },
  {
    key: "Neuheit",
    text: translate( "Neuheit" ),
    value: "creationdate",
    params: { sort: "creationdate", dir: "desc" }
  },
  {
    key: "Topseller",
    text: translate( "Topseller" ),
    value: "topseller",
    params: { sort: "topseller", dir: "desc" }
  },
]

const pageCountOptions = [
  {
    key: "12",
    text: "12",
    value: "12"
  },
  {
    key: "24",
    text: "24",
    value: "24"
  },
  {
    key: "32",
    text: "32",
    value: "32"
  },
  {
    key: "64",
    text: "64",
    value: "64"
  }
]


export default class Filter extends Component {

  componentDidMount() {

  }

  handlePageSelect = ( page ) => {
    this.props.onChange( { page } )
  }

  render() {
    shop.config.standards.SORT = "article_nr"
    const { hidePagination, hidePageSize, hideDirections, onlyPagination, hideViewChange = false, dir,view = "grid", sort = shop.config.standards.SORT, count } = this.props
    if ( onlyPagination ) {
      return <div className="cb overflow-hidden pb3 tc">
        <Pagination filter={this.props}
                    onChange={this.handlePageSelect}/>
      </div>
    }

    return <div>
      <Form>
        <div className="flex justify-between">
          <div className="">
            {!hidePagination && <Pagination filter={this.props}
                                            onChange={this.handlePageSelect}/>}
          </div>


          <div className="flex justify-end">
            <div className="pr2" style={{ width: "80px" }}>
              {!hidePageSize && <div>
                <div className={"black-60 pb1"}><label htmlFor="">{translate( "Artikel pro Seite" )}</label></div>
                <Dropdown
                  fluid
                  value={count}
                  selection
                  options={pageCountOptions}
                  onChange={( e, { value } ) => {
                    console.log( { pageSize: value } )
                    this.props.onChange( { pageSize: value } )

                  }}
                />
              </div>}
            </div>


            <div className={`${!hideDirections ? "pr2" : "pr0"}`}>
              <div className={"black-60 pb1"}><label htmlFor="">{translate( "Sortierung" )}</label></div>
              <Dropdown
                value={sort}
                selection
                options={sortOptions}
                onChange={( e, { value } ) => {
                  let item = sortOptions.find( item => item.value === value )
                  if ( item ) {
                    this.props.onChange( item.params )
                  }
                }}
              />
            </div>

            {!hideDirections && <div>
              <div className={"black-60 pb1"}><label htmlFor="">&nbsp;</label></div>
              <Button.Group basic size="small">
                <Button active={dir === "desc"} onClick={() => {
                  this.props.onChange( { dir: "desc" } )
                }} icon={"chevron down"}/>
                <Button active={dir === "asc"} onClick={() => {
                  this.props.onChange( { dir: "asc" } )
                }} icon={"chevron up"}/>
              </Button.Group>
            </div>
            }
            {!hideViewChange && <div className={"pl2 pr0"}>
              <div className={"black-60 pb1"}><label htmlFor="">&nbsp;</label></div>
              <Button.Group basic size="small">
                <Button as={Link} to={"./?view=grid"} active={view === "grid"} onClick={() => {
                  this.props.onChange( { view: "grid" } )
                }} icon={"th"}/>
                <Button as={Link} to={"./?view=list"} active={view === "list"} onClick={() => {
                  this.props.onChange( { view: "list" } )
                }} icon={"th list"}/>
                
              </Button.Group>
            </div>
            }
          </div>

        </div>
      </Form>
    </div>
  }
}


//
// export  class Filter2 extends Component {
//
//   constructor( props ) {
//     super()
//     this.onChange = props.onChange
//     // sort: Artikelsortierung (mögliche Werte: article_nr,price,des,sort,map_id (ArtikelId) ,stock (Lagerbestand))
//     this.sortOptions = [
//       {
//         label: "A-Z",
//         value: "des&dir=asc"
//       },
//       {
//         label: "Artikel-Nr.",
//         value: "article_nr"
//       },
//       {
//         label: "Beliebtheit2",
//         value: {sort: "sort", dir: "desc"}
//       },
//       {
//         label: "Niedrigster Preis",
//         value: "price&dir=asc"
//       },
//       {
//         label: "Höchster Preis",
//         value: "price&dir=desc"
//       },
//       {
//         label: "Neuheit",
//         value: "creationdate"
//       }
//     ]
//
//     this.pageCountOptions = [
//       {
//         label: "12",
//         value: "12"
//       },
//       {
//         label: "24",
//         value: "24"
//       },
//       {
//         label: "32",
//         value: "32"
//       },
//       {
//         label: "64",
//         value: "64"
//       }
//     ]
//   }
//
//   componentWillReceiveProps( props ) {
//     return props
//   }
//
//   handlePageSelect = ( page ) => {
//     console.log( `page:`, page )
//     this.onChange( { page } )
//   }
//
//   render() {
//     let hasDesigners = this.props.designOptions && this.props.designOptions.length > 1
//     let hasBrands = this.props.brandOptions && this.props.brandOptions.length > 1
//     let hidePagination = this.props.hidePagination
//     let hidePageSize = this.props.hidePageSize || false
//
//     if ( this.props.onlyPagination ) {
//       return <div className="cb overflow-hidden pb3 tc">
//         <Pagination filter={this.props}
//                     onChange={this.handlePageSelect}/>
//       </div>
//     }
//     return (
//       <div className="filter">
//         {(this.props.showFilter) ? <Row>
//
//           <Col sm="1" md="1">
//             <Form>
//               <FormField label={translate( "Sort by" )}
//                          htmlFor="form-sort">
//                 <FormSelect
//                   name="form-sort"
//                   value={this.props.sort}
//                   options={this.sortOptions}
//                   onChange={( sort ) => {
//                     this.onChange( { sort } )
//                   }}/>
//               </FormField>
//             </Form>
//
//             {!hidePageSize && <Form>
//               <FormField label={translate( "Page" )}
//                          htmlFor="form-count">
//                 <FormSelect
//                   value={String( this.props.pageSize )}
//                   name="form-count"
//                   options={this.pageCountOptions}
//                   onChange={( pageSize ) => {
//                     this.onChange( {
//                       pageSize,
//                       page: 1
//                     } )
//                   }}/>
//               </FormField>
//             </Form>}
//             {!hidePagination && <Pagination filter={this.props}
//                                             onChange={this.handlePageSelect}/>}
//             {/*SELECT BRAND*/}
//             {hasBrands && <Form>
//               <FormField
//                 className="filter-brands"
//                 label="Marken"
//                 htmlFor="form-count">
//                 <FormSelect
//                   value={String( this.props.brand )}
//                   name="form-count"
//                   options={this.props.brandOptions}
//                   onChange={( brand ) => {
//                     this.onChange( {
//                       brand,
//                       design: false,
//                       page:   1
//                     } )
//                   }}/>
//               </FormField>
//             </Form>}
//
//             {/*SELECT DESIGNER*/}
//             {hasDesigners && <Form>
//               <FormField
//                 className="filter-designers"
//                 label="Designer"
//                 htmlFor="form-count">
//                 <FormSelect
//                   value={String( this.props.design )}
//                   name="form-count"
//                   options={this.props.designOptions}
//                   onChange={( design ) => {
//                     this.onChange( {
//                       brand: false,
//                       design,
//                       page:  1
//                     } )
//                   }}/>
//               </FormField>
//             </Form>}
//           </Col>
//         </Row> : null}
//       </div>
//     )
//   }
// }
//
// Filter.defaultProps = {
//   onChange:    () => {
//   },
//   currentPage: 1,
//   pageSize:    6,
//   limit:       4,
//   showFilter:  true,
// }
//
// Filter.propTypes = {
//   onChange:    PropTypes.func,
//   sort:        PropTypes.string,
//   currentPage: PropTypes.number,
//   pageSize:    PropTypes.number,
//   plural:      PropTypes.string,
//   singular:    PropTypes.string,
//   total:       PropTypes.number,
//   limit:       PropTypes.number,
//   showFilter:  PropTypes.bool
// }



// WEBPACK FOOTER //
// ./src/theme/trendimport.test/components/Filter/Filter.js